/* tslint:disable */

// this is an auto generated file. This will be overwritten

import * as APITypes from '../API';
type GeneratedQuery<InputType, OutputType> = string & {
  __generatedQueryInput: InputType;
  __generatedQueryOutput: OutputType;
};

export const ca_user_validation = /* GraphQL */ `query Ca_user_validation($emp_login: String!) {
  ca_user_validation(emp_login: $emp_login) {
    body {
      exact_match {
        amzn_loc_desc
        building
        business_title
        city
        company
        country
        department_id
        department_name
        employee_email
        employee_first_name
        employee_id
        employee_last_name
        employee_login
        employee_name
        hire_date
        is_tobias_org
        job_code
        job_family
        job_title
        location
        supervisor_lvl10_id
        supervisor_lvl10_login
        supervisor_lvl10_name
        supervisor_lvl11_id
        supervisor_lvl11_login
        supervisor_lvl11_name
        supervisor_lvl1_email
        supervisor_lvl1_id
        supervisor_lvl1_login
        supervisor_lvl1_name
        supervisor_lvl2_id
        supervisor_lvl2_login
        supervisor_lvl2_name
        supervisor_lvl3_id
        supervisor_lvl3_login
        supervisor_lvl3_name
        supervisor_lvl4_id
        supervisor_lvl4_login
        supervisor_lvl4_name
        supervisor_lvl5_id
        supervisor_lvl5_login
        supervisor_lvl5_name
        supervisor_lvl6_id
        supervisor_lvl6_login
        supervisor_lvl6_name
        supervisor_lvl7_id
        supervisor_lvl7_login
        supervisor_lvl7_name
        supervisor_lvl8_id
        supervisor_lvl8_login
        supervisor_lvl8_name
        supervisor_lvl9_id
        supervisor_lvl9_login
        supervisor_lvl9_name
        tree_depth
      }
      fuzzy_match {
        amzn_loc_desc
        building
        business_title
        city
        company
        country
        department_id
        department_name
        employee_email
        employee_first_name
        employee_id
        employee_last_name
        employee_login
        employee_name
        hire_date
        is_tobias_org
        job_code
        job_family
        job_title
        location
        supervisor_lvl10_id
        supervisor_lvl10_login
        supervisor_lvl10_name
        supervisor_lvl11_id
        supervisor_lvl11_login
        supervisor_lvl11_name
        supervisor_lvl1_email
        supervisor_lvl1_id
        supervisor_lvl1_login
        supervisor_lvl1_name
        supervisor_lvl2_id
        supervisor_lvl2_login
        supervisor_lvl2_name
        supervisor_lvl3_id
        supervisor_lvl3_login
        supervisor_lvl3_name
        supervisor_lvl4_id
        supervisor_lvl4_login
        supervisor_lvl4_name
        supervisor_lvl5_id
        supervisor_lvl5_login
        supervisor_lvl5_name
        supervisor_lvl6_id
        supervisor_lvl6_login
        supervisor_lvl6_name
        supervisor_lvl7_id
        supervisor_lvl7_login
        supervisor_lvl7_name
        supervisor_lvl8_id
        supervisor_lvl8_login
        supervisor_lvl8_name
        supervisor_lvl9_id
        supervisor_lvl9_login
        supervisor_lvl9_name
        tree_depth
      }
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Ca_user_validationQueryVariables, APITypes.Ca_user_validationQuery>;
export const get_acc_proj = /* GraphQL */ `query Get_acc_proj {
  get_acc_proj {
    body {
      accessory_product_code
      accessory_project_code
      accessory_project_name
      id
      project_code
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_acc_projQueryVariables, APITypes.Get_acc_projQuery>;
export const get_accounts = /* GraphQL */ `query Get_accounts {
  get_accounts {
    body {
      account_code
      budget_type
      description
      id
      parent_account_code
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_accountsQueryVariables, APITypes.Get_accountsQuery>;
export const get_agm_assort = /* GraphQL */ `query Get_agm_assort($verity_rpn_id: Int) {
  get_agm_assort(verity_rpn_id: $verity_rpn_id) {
    body {
      assortment_id
      channel
      country
      marketplace
      obfuscated_marketplace_id
      row
      sku_type
      status
      version_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_agm_assortQueryVariables, APITypes.Get_agm_assortQuery>;
export const get_agm_prog_att_sort = /* GraphQL */ `query Get_agm_prog_att_sort($verity_rpn_id: Int) {
  get_agm_prog_att_sort(verity_rpn_id: $verity_rpn_id) {
    body {
      at_concat_order
      attribute_type
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_agm_prog_att_sortQueryVariables, APITypes.Get_agm_prog_att_sortQuery>;
export const get_agm_prog_version = /* GraphQL */ `query Get_agm_prog_version($verity_rpn_id: Int) {
  get_agm_prog_version(verity_rpn_id: $verity_rpn_id) {
    body {
      attribute_type
      attribute_value
      version_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_agm_prog_versionQueryVariables, APITypes.Get_agm_prog_versionQuery>;
export const get_agm_sku = /* GraphQL */ `query Get_agm_sku($verity_rpn_id: Int) {
  get_agm_sku(verity_rpn_id: $verity_rpn_id) {
    body {
      additional_marketplaces
      asin
      assortment_id
      blocked_ts
      fpn
      is_deactivated
      notification_status
      pn
      sku_id
      sku_type
      verity_fpn_id
      version_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_agm_skuQueryVariables, APITypes.Get_agm_skuQuery>;
export const get_asin_lookup = /* GraphQL */ `query Get_asin_lookup($parameter_name: String, $parameter_value: String) {
  get_asin_lookup(
    parameter_name: $parameter_name
    parameter_value: $parameter_value
  ) {
    body {
      asin
      brand
      device_type
      manufacturer_vendor_code
      part_number
      product_line_id
      product_line_ppls_id
      program_partiness
      program_ppls_id
      rtip_vendor_code
      sc_vendor_name
      sku_type
      upc
      verity_rpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_asin_lookupQueryVariables, APITypes.Get_asin_lookupQuery>;
export const get_asin_program_mapping = /* GraphQL */ `query Get_asin_program_mapping($fpn_id: Int, $rpn_id: Int!) {
  get_asin_program_mapping(fpn_id: $fpn_id, rpn_id: $rpn_id) {
    body {
      asin
      created_by
      created_ts
      fpn
      fpn_id
      is_deprecated
      part_number
      sku_description
      sku_type
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_asin_program_mappingQueryVariables, APITypes.Get_asin_program_mappingQuery>;
export const get_asinattr_l1 = /* GraphQL */ `query Get_asinattr_l1($verity_fpn_id: Int, $verity_rpn_id: Int) {
  get_asinattr_l1(
    verity_fpn_id: $verity_fpn_id
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      channel
      color
      country
      fpn
      product_line
      product_type
      rpn
      sku_type
      verity_fpn_id
      verity_product_line_id
      verity_rpn_id
      version
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_asinattr_l1QueryVariables, APITypes.Get_asinattr_l1Query>;
export const get_asinattr_l2 = /* GraphQL */ `query Get_asinattr_l2($verity_fpn_id: Int, $verity_rpn_id: Int) {
  get_asinattr_l2(
    verity_fpn_id: $verity_fpn_id
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      attribute_type
      attribute_value
      fpn
      product_line
      rpn
      verity_fpn_id
      verity_product_line_id
      verity_rpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_asinattr_l2QueryVariables, APITypes.Get_asinattr_l2Query>;
export const get_asinattr_l3 = /* GraphQL */ `query Get_asinattr_l3($verity_fpn_id: Int, $verity_rpn_id: Int) {
  get_asinattr_l3(
    verity_fpn_id: $verity_fpn_id
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      attribute_type
      attribute_value
      fpn
      product_line
      rpn
      verity_fpn_id
      verity_product_line_id
      verity_rpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_asinattr_l3QueryVariables, APITypes.Get_asinattr_l3Query>;
export const get_attr_list_fpn = /* GraphQL */ `query Get_attr_list_fpn(
  $attribute_type: String
  $is_deprecated: Boolean
  $verity_fpn_id: Int!
) {
  get_attr_list_fpn(
    attribute_type: $attribute_type
    is_deprecated: $is_deprecated
    verity_fpn_id: $verity_fpn_id
  ) {
    body {
      asin_count
      attribute_type
      attribute_value
      verity_fpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_attr_list_fpnQueryVariables, APITypes.Get_attr_list_fpnQuery>;
export const get_attr_list_master = /* GraphQL */ `query Get_attr_list_master(
  $attribute_type: String
  $attribute_value: String
  $is_deprecated: Boolean
) {
  get_attr_list_master(
    attribute_type: $attribute_type
    attribute_value: $attribute_value
    is_deprecated: $is_deprecated
  ) {
    body {
      attribute_type
      attribute_value
      comments
      id
      is_deprecated
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_attr_list_masterQueryVariables, APITypes.Get_attr_list_masterQuery>;
export const get_attr_list_rpn = /* GraphQL */ `query Get_attr_list_rpn(
  $attribute_type: String
  $is_deprecated: Boolean
  $verity_rpn_id: Int!
) {
  get_attr_list_rpn(
    attribute_type: $attribute_type
    is_deprecated: $is_deprecated
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      asin_count
      attribute_type
      attribute_value
      rpn
      verity_rpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_attr_list_rpnQueryVariables, APITypes.Get_attr_list_rpnQuery>;
export const get_attr_type_master = /* GraphQL */ `query Get_attr_type_master(
  $attribute_type: String
  $is_deprecated: Boolean
  $is_std_attr: Boolean
) {
  get_attr_type_master(
    attribute_type: $attribute_type
    is_deprecated: $is_deprecated
    is_std_attr: $is_std_attr
  ) {
    body {
      attribute_type
      comments
      id
      is_deprecated
      is_std_attr
      label
      std_attr_order
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_attr_type_masterQueryVariables, APITypes.Get_attr_type_masterQuery>;
export const get_attr_type_rpn = /* GraphQL */ `query Get_attr_type_rpn(
  $attribute_type: String
  $is_deprecated: Boolean
  $rpn: String
  $verity_rpn_id: Int
) {
  get_attr_type_rpn(
    attribute_type: $attribute_type
    is_deprecated: $is_deprecated
    rpn: $rpn
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      attribute_type
      comments
      id
      in_fpn
      is_deprecated
      is_rpn_attr
      rpn
      rpn_attr_order
      used_in_fpn
      verity_rpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_attr_type_rpnQueryVariables, APITypes.Get_attr_type_rpnQuery>;
export const get_attribute_list_pl = /* GraphQL */ `query Get_attribute_list_pl(
  $attribute_type: String
  $is_deprecated: Boolean
  $product_line: String
  $verity_product_line_id: Int
) {
  get_attribute_list_pl(
    attribute_type: $attribute_type
    is_deprecated: $is_deprecated
    product_line: $product_line
    verity_product_line_id: $verity_product_line_id
  ) {
    body {
      attribute_type
      attribute_value
      comments
      id
      is_deprecated
      product_line
      verity_product_line_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_attribute_list_plQueryVariables, APITypes.Get_attribute_list_plQuery>;
export const get_attribute_type_pl = /* GraphQL */ `query Get_attribute_type_pl(
  $attribute_type: String
  $is_deprecated: Boolean
  $is_pl_attr: Boolean
  $product_line: String
  $verity_product_line_id: Int
) {
  get_attribute_type_pl(
    attribute_type: $attribute_type
    is_deprecated: $is_deprecated
    is_pl_attr: $is_pl_attr
    product_line: $product_line
    verity_product_line_id: $verity_product_line_id
  ) {
    body {
      attribute_type
      comments
      id
      in_fpn
      is_deprecated
      is_pl_attr
      pl_attr_order
      product_line
      verity_product_line_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_attribute_type_plQueryVariables, APITypes.Get_attribute_type_plQuery>;
export const get_bdgt_typ = /* GraphQL */ `query Get_bdgt_typ {
  get_bdgt_typ {
    body {
      budget_type
      description
      id
      long_label
      short_label
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_bdgt_typQueryVariables, APITypes.Get_bdgt_typQuery>;
export const get_budget_bl = /* GraphQL */ `query Get_budget_bl {
  get_budget_bl {
    body {
      account_type
      budget_type
      cost_center_category
      cost_center_code
      id
      line_item
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_budget_blQueryVariables, APITypes.Get_budget_blQuery>;
export const get_cc = /* GraphQL */ `query Get_cc {
  get_cc {
    body {
      comments
      cost_center_code
      cost_center_function_head
      cost_center_group
      cost_center_manager
      cost_center_name
      cost_center_type
      depreciation_months
      hc_finance_contact
      id
      non_hc_finance_contact
      organization
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_ccQueryVariables, APITypes.Get_ccQuery>;
export const get_cc_cat = /* GraphQL */ `query Get_cc_cat {
  get_cc_cat {
    body {
      cost_center_category
      id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_cc_catQueryVariables, APITypes.Get_cc_catQuery>;
export const get_cc_el = /* GraphQL */ `query Get_cc_el {
  get_cc_el {
    body {
      budget_type
      cost_center_code
      id
      line_item
      line_item_description
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_cc_elQueryVariables, APITypes.Get_cc_elQuery>;
export const get_cc_gr = /* GraphQL */ `query Get_cc_gr {
  get_cc_gr {
    body {
      cost_center_group
      description
      id
      long_label
      short_label
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_cc_grQueryVariables, APITypes.Get_cc_grQuery>;
export const get_comdty = /* GraphQL */ `query Get_comdty {
  get_comdty {
    body {
      commodity
      description
      id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_comdtyQueryVariables, APITypes.Get_comdtyQuery>;
export const get_exp_typ = /* GraphQL */ `query Get_exp_typ {
  get_exp_typ {
    body {
      budget_type
      description
      expense_type
      id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_exp_typQueryVariables, APITypes.Get_exp_typQuery>;
export const get_exp_up_re = /* GraphQL */ `query Get_exp_up_re {
  get_exp_up_re {
    body {
      description
      expense_update_reason
      id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_exp_up_reQueryVariables, APITypes.Get_exp_up_reQuery>;
export const get_fpn = /* GraphQL */ `query Get_fpn(
  $fpn: String
  $is_deprecated: Boolean
  $is_fpn_key_active: Boolean
  $product_line: String
  $rpn: String
  $verity_fpn_id: Int
  $verity_product_line_id: Int
  $verity_rpn_id: Int
) {
  get_fpn(
    fpn: $fpn
    is_deprecated: $is_deprecated
    is_fpn_key_active: $is_fpn_key_active
    product_line: $product_line
    rpn: $rpn
    verity_fpn_id: $verity_fpn_id
    verity_product_line_id: $verity_product_line_id
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      asin_count
      fpn
      is_current
      is_deprecated
      is_fpn_key_active
      ppls_id
      product_line
      rpn
      verity_fpn_id
      verity_product_line_id
      verity_rpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_fpnQueryVariables, APITypes.Get_fpnQuery>;
export const get_frms_cc = /* GraphQL */ `query Get_frms_cc {
  get_frms_cc {
    body {
      code_id
      code_name
      code_status
      created_by
      created_on
      enabled
      hierarchy_relationship_type
      is_child
      is_parent
      last_updated_by
      last_updated_on
      loadedOn
      parent_code_id
      payload
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_frms_ccQueryVariables, APITypes.Get_frms_ccQuery>;
export const get_frms_prod = /* GraphQL */ `query Get_frms_prod {
  get_frms_prod {
    body {
      code_id
      code_name
      code_status
      created_by
      created_on
      enabled
      hierarchy_relationship_type
      is_child
      is_parent
      last_updated_by
      last_updated_on
      loadedOn
      parent_code_id
      payload
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_frms_prodQueryVariables, APITypes.Get_frms_prodQuery>;
export const get_frms_proj = /* GraphQL */ `query Get_frms_proj {
  get_frms_proj {
    body {
      code_id
      code_name
      code_status
      created_by
      created_on
      enabled
      hierarchy_relationship_type
      is_child
      is_parent
      last_updated_by
      last_updated_on
      loadedOn
      parent_code_id
      payload
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_frms_projQueryVariables, APITypes.Get_frms_projQuery>;
export const get_line_item = /* GraphQL */ `query Get_line_item {
  get_line_item {
    body {
      id
      line_item
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_line_itemQueryVariables, APITypes.Get_line_itemQuery>;
export const get_marketplace = /* GraphQL */ `query Get_marketplace {
  get_marketplace {
    body {
      country
      marketplace
      obfuscated_marketplace_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_marketplaceQueryVariables, APITypes.Get_marketplaceQuery>;
export const get_nav_bar = /* GraphQL */ `query Get_nav_bar {
  get_nav_bar {
    body {
      product_line
      rpn {
        fpn {
          fpn
          verity_fpn_id
        }
        is_on_roadmap
        rpn
        verity_rpn_id
      }
      verity_product_line_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_nav_barQueryVariables, APITypes.Get_nav_barQuery>;
export const get_pl_fpn_rule = /* GraphQL */ `query Get_pl_fpn_rule(
  $attribute_type: String
  $is_deprecated: Boolean
  $product_line: String
  $verity_product_line_id: Int
) {
  get_pl_fpn_rule(
    attribute_type: $attribute_type
    is_deprecated: $is_deprecated
    product_line: $product_line
    verity_product_line_id: $verity_product_line_id
  ) {
    body {
      attribute_type
      comments
      concat_order
      is_deprecated
      is_required
      ppls_id
      product_line
      verity_product_line_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_pl_fpn_ruleQueryVariables, APITypes.Get_pl_fpn_ruleQuery>;
export const get_prm_attributes =
  /* GraphQL */ `query Get_prm_attributes($for_chart: Boolean, $is_deprecated: Boolean) {
  get_prm_attributes(for_chart: $for_chart, is_deprecated: $is_deprecated) {
    body {
      attribute_id
      attribute_label
      attribute_type
      attribute_value
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_prm_attributesQueryVariables, APITypes.Get_prm_attributesQuery>;
export const get_prm_gantt_chart_data = /* GraphQL */ `query Get_prm_gantt_chart_data(
  $chart_filters: ChartFiltersInput
  $product_line_id: Int
) {
  get_prm_gantt_chart_data(
    chart_filters: $chart_filters
    product_line_id: $product_line_id
  ) {
    body {
      attributes {
        attribute_id
        attribute_label
        attribute_type
        attribute_value
      }
      end_date
      program_alias
      program_id
      start_date
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_prm_gantt_chart_dataQueryVariables, APITypes.Get_prm_gantt_chart_dataQuery>;
export const get_prm_scenarios = /* GraphQL */ `query Get_prm_scenarios($exclude_automatic_scenarios: Boolean) {
  get_prm_scenarios(exclude_automatic_scenarios: $exclude_automatic_scenarios) {
    body {
      is_automatic
      scenario_id
      scenario_name
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_prm_scenariosQueryVariables, APITypes.Get_prm_scenariosQuery>;
export const get_product_gr = /* GraphQL */ `query Get_product_gr {
  get_product_gr {
    body {
      description
      id
      product_group
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_product_grQueryVariables, APITypes.Get_product_grQuery>;
export const get_product_hierarchy = /* GraphQL */ `query Get_product_hierarchy(
  $fpn: String
  $is_deprecated: Boolean
  $product_line: String
  $program: String
  $verity_fpn_id: Int
  $verity_product_line_id: Int
  $verity_rpn_id: Int
) {
  get_product_hierarchy(
    fpn: $fpn
    is_deprecated: $is_deprecated
    product_line: $product_line
    program: $program
    verity_fpn_id: $verity_fpn_id
    verity_product_line_id: $verity_product_line_id
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      gl_product_group
      is_deprecated
      ppls_product_line_id
      product_code
      product_line
      product_line_alias
      rpn {
        asin_count
        comment
        created_ts
        description
        fpn {
          asin_count
          fpn
          is_current
          is_deprecated
          is_fpn_key_active
          ppls_id
          product_line
          rpn
          verity_fpn_id
          verity_product_line_id
          verity_rpn_id
        }
        is_brd_approved
        is_current
        is_deprecated
        is_name_approved
        is_on_roadmap
        is_placeholder
        ppls_id
        prfaq_approval_status
        prfaq_link
        product_code
        product_line
        program_status
        program_status_last_updated_by
        program_status_last_updated_ts
        rpn
        rpn_alias
        verity_product_line_id
        verity_rpn_id
      }
      verity_product_line_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_product_hierarchyQueryVariables, APITypes.Get_product_hierarchyQuery>;
export const get_product_line = /* GraphQL */ `query Get_product_line(
  $is_deprecated: Boolean
  $product_code: String
  $product_line: String
  $product_line_alias: String
  $verity_product_line_id: Int
  $verity_version: String
) {
  get_product_line(
    is_deprecated: $is_deprecated
    product_code: $product_code
    product_line: $product_line
    product_line_alias: $product_line_alias
    verity_product_line_id: $verity_product_line_id
    verity_version: $verity_version
  ) {
    body {
      gl_product_group
      is_deprecated
      ppls_product_line_id
      product_code
      product_line
      product_line_alias
      rpn {
        asin_count
        comment
        created_ts
        description
        fpn {
          asin_count
          fpn
          is_current
          is_deprecated
          is_fpn_key_active
          ppls_id
          product_line
          rpn
          verity_fpn_id
          verity_product_line_id
          verity_rpn_id
        }
        is_brd_approved
        is_current
        is_deprecated
        is_name_approved
        is_on_roadmap
        is_placeholder
        ppls_id
        prfaq_approval_status
        prfaq_link
        product_code
        product_line
        program_status
        program_status_last_updated_by
        program_status_last_updated_ts
        rpn
        rpn_alias
        verity_product_line_id
        verity_rpn_id
      }
      verity_product_line_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_product_lineQueryVariables, APITypes.Get_product_lineQuery>;
export const get_products = /* GraphQL */ `query Get_products {
  get_products {
    body {
      comments
      geo_market
      id
      is_accessory
      product_code
      product_group
      product_name
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_productsQueryVariables, APITypes.Get_productsQuery>;
export const get_projects = /* GraphQL */ `query Get_projects {
  get_projects {
    body {
      accessory_product_code
      accessory_project_name
      baseline_date
      complexity_factor
      depreciation_months
      device_product_code
      device_project_name
      id
      is_active
      is_mfr
      pred_project_code
      pred_project_name
      product_life_in_months
      proj_hw_id
      project_code
      street_date
      street_name
      sub_device_project_name
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_projectsQueryVariables, APITypes.Get_projectsQuery>;
export const get_roles_agm = /* GraphQL */ `query Get_roles_agm(
  $resource_name: String
  $user_name: String
  $user_type: String
) {
  get_roles_agm(
    resource_name: $resource_name
    user_name: $user_name
    user_type: $user_type
  ) {
    body {
      name
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_roles_agmQueryVariables, APITypes.Get_roles_agmQuery>;
export const get_roles_coa = /* GraphQL */ `query Get_roles_coa(
  $resource_name: String
  $user_name: String
  $user_type: String
) {
  get_roles_coa(
    resource_name: $resource_name
    user_name: $user_name
    user_type: $user_type
  ) {
    body {
      name
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_roles_coaQueryVariables, APITypes.Get_roles_coaQuery>;
export const get_roles_snro = /* GraphQL */ `query Get_roles_snro(
  $resource_name: String
  $user_name: String
  $user_type: String
) {
  get_roles_snro(
    resource_name: $resource_name
    user_name: $user_name
    user_type: $user_type
  ) {
    body {
      name
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_roles_snroQueryVariables, APITypes.Get_roles_snroQuery>;
export const get_roles_verity_dg = /* GraphQL */ `query Get_roles_verity_dg(
  $resource_name: String
  $user_name: String
  $user_type: String
) {
  get_roles_verity_dg(
    resource_name: $resource_name
    user_name: $user_name
    user_type: $user_type
  ) {
    body {
      name
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_roles_verity_dgQueryVariables, APITypes.Get_roles_verity_dgQuery>;
export const get_rpn = /* GraphQL */ `query Get_rpn(
  $is_deprecated: Boolean
  $product_line: String
  $rpn: String
  $rpn_alias: String
  $verity_product_line_id: Int
  $verity_rpn_id: Int
) {
  get_rpn(
    is_deprecated: $is_deprecated
    product_line: $product_line
    rpn: $rpn
    rpn_alias: $rpn_alias
    verity_product_line_id: $verity_product_line_id
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      asin_count
      comment
      created_ts
      description
      fpn {
        asin_count
        fpn
        is_current
        is_deprecated
        is_fpn_key_active
        ppls_id
        product_line
        rpn
        verity_fpn_id
        verity_product_line_id
        verity_rpn_id
      }
      is_brd_approved
      is_current
      is_deprecated
      is_name_approved
      is_on_roadmap
      is_placeholder
      ppls_id
      prfaq_approval_status
      prfaq_link
      product_code
      product_line
      program_status
      program_status_last_updated_by
      program_status_last_updated_ts
      rpn
      rpn_alias
      verity_product_line_id
      verity_rpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_rpnQueryVariables, APITypes.Get_rpnQuery>;
export const get_rpn_fpn_rule = /* GraphQL */ `query Get_rpn_fpn_rule(
  $attribute_type: String
  $is_deprecated: Boolean
  $product_line: String
  $rpn: String
  $verity_product_line_id: Int
  $verity_rpn_id: Int
) {
  get_rpn_fpn_rule(
    attribute_type: $attribute_type
    is_deprecated: $is_deprecated
    product_line: $product_line
    rpn: $rpn
    verity_product_line_id: $verity_product_line_id
    verity_rpn_id: $verity_rpn_id
  ) {
    body {
      attribute_type
      comments
      concat_order
      is_deprecated
      ppls_id
      product_line
      rpn
      verity_product_line_id
      verity_rpn_id
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_rpn_fpn_ruleQueryVariables, APITypes.Get_rpn_fpn_ruleQuery>;
export const get_user_access = /* GraphQL */ `query Get_user_access($user_name: String) {
  get_user_access(user_name: $user_name) {
    body {
      resource {
        name
        resources {
          name
          resources {
            name
            resources {
              name
              resources {
                name
                resources {
                  name
                  resources {
                    name
                    resources {
                      name
                      resources {
                        name
                        resources {
                          name
                          resources {
                            name
                            resources {
                              name
                              resources {
                                name
                                resources {
                                  name
                                  resources {
                                    name
                                    resources {
                                      name
                                      resources {
                                        name
                                        resources {
                                          name
                                          resources {
                                            name
                                            resources {
                                              name
                                              resources {
                                                name
                                                resources {
                                                  name
                                                  resources {
                                                    name
                                                    resources {
                                                      name
                                                      resources {
                                                        name
                                                        resources {
                                                          name
                                                          resources {
                                                            name
                                                            resources {
                                                              name
                                                              resources {
                                                                name
                                                                resources {
                                                                  name
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      roles {
        name
      }
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_user_accessQueryVariables, APITypes.Get_user_accessQuery>;
export const get_user_access_agm = /* GraphQL */ `query Get_user_access_agm($user_name: String, $user_type: String) {
  get_user_access_agm(user_name: $user_name, user_type: $user_type) {
    body {
      resource {
        name
        resources {
          name
          resources {
            name
            resources {
              name
              resources {
                name
                resources {
                  name
                  resources {
                    name
                    resources {
                      name
                      resources {
                        name
                        resources {
                          name
                          resources {
                            name
                            resources {
                              name
                              resources {
                                name
                                resources {
                                  name
                                  resources {
                                    name
                                    resources {
                                      name
                                      resources {
                                        name
                                        resources {
                                          name
                                          resources {
                                            name
                                            resources {
                                              name
                                              resources {
                                                name
                                                resources {
                                                  name
                                                  resources {
                                                    name
                                                    resources {
                                                      name
                                                      resources {
                                                        name
                                                        resources {
                                                          name
                                                          resources {
                                                            name
                                                            resources {
                                                              name
                                                              resources {
                                                                name
                                                                resources {
                                                                  name
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      roles {
        name
      }
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_user_access_agmQueryVariables, APITypes.Get_user_access_agmQuery>;
export const get_user_access_coa = /* GraphQL */ `query Get_user_access_coa($user_name: String, $user_type: String) {
  get_user_access_coa(user_name: $user_name, user_type: $user_type) {
    body {
      resource {
        name
        resources {
          name
          resources {
            name
            resources {
              name
              resources {
                name
                resources {
                  name
                  resources {
                    name
                    resources {
                      name
                      resources {
                        name
                        resources {
                          name
                          resources {
                            name
                            resources {
                              name
                              resources {
                                name
                                resources {
                                  name
                                  resources {
                                    name
                                    resources {
                                      name
                                      resources {
                                        name
                                        resources {
                                          name
                                          resources {
                                            name
                                            resources {
                                              name
                                              resources {
                                                name
                                                resources {
                                                  name
                                                  resources {
                                                    name
                                                    resources {
                                                      name
                                                      resources {
                                                        name
                                                        resources {
                                                          name
                                                          resources {
                                                            name
                                                            resources {
                                                              name
                                                              resources {
                                                                name
                                                                resources {
                                                                  name
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      roles {
        name
      }
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_user_access_coaQueryVariables, APITypes.Get_user_access_coaQuery>;
export const get_user_access_snro = /* GraphQL */ `query Get_user_access_snro($user_name: String, $user_type: String) {
  get_user_access_snro(user_name: $user_name, user_type: $user_type) {
    body {
      resource {
        name
        resources {
          name
          resources {
            name
            resources {
              name
              resources {
                name
                resources {
                  name
                  resources {
                    name
                    resources {
                      name
                      resources {
                        name
                        resources {
                          name
                          resources {
                            name
                            resources {
                              name
                              resources {
                                name
                                resources {
                                  name
                                  resources {
                                    name
                                    resources {
                                      name
                                      resources {
                                        name
                                        resources {
                                          name
                                          resources {
                                            name
                                            resources {
                                              name
                                              resources {
                                                name
                                                resources {
                                                  name
                                                  resources {
                                                    name
                                                    resources {
                                                      name
                                                      resources {
                                                        name
                                                        resources {
                                                          name
                                                          resources {
                                                            name
                                                            resources {
                                                              name
                                                              resources {
                                                                name
                                                                resources {
                                                                  name
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      roles {
        name
      }
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_user_access_snroQueryVariables, APITypes.Get_user_access_snroQuery>;
export const get_user_access_verity_dg =
  /* GraphQL */ `query Get_user_access_verity_dg($user_name: String, $user_type: String) {
  get_user_access_verity_dg(user_name: $user_name, user_type: $user_type) {
    body {
      resource {
        name
        resources {
          name
          resources {
            name
            resources {
              name
              resources {
                name
                resources {
                  name
                  resources {
                    name
                    resources {
                      name
                      resources {
                        name
                        resources {
                          name
                          resources {
                            name
                            resources {
                              name
                              resources {
                                name
                                resources {
                                  name
                                  resources {
                                    name
                                    resources {
                                      name
                                      resources {
                                        name
                                        resources {
                                          name
                                          resources {
                                            name
                                            resources {
                                              name
                                              resources {
                                                name
                                                resources {
                                                  name
                                                  resources {
                                                    name
                                                    resources {
                                                      name
                                                      resources {
                                                        name
                                                        resources {
                                                          name
                                                          resources {
                                                            name
                                                            resources {
                                                              name
                                                              resources {
                                                                name
                                                                resources {
                                                                  name
                                                                }
                                                              }
                                                            }
                                                          }
                                                        }
                                                      }
                                                    }
                                                  }
                                                }
                                              }
                                            }
                                          }
                                        }
                                      }
                                    }
                                  }
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
      roles {
        name
      }
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Get_user_access_verity_dgQueryVariables, APITypes.Get_user_access_verity_dgQuery>;
export const listAGMProgramVersion = /* GraphQL */ `query ListAGMProgramVersion($input: RPNIdInput!) {
  listAGMProgramVersion(input: $input) {
    attribute_type
    attribute_value
    version_id
  }
}
` as GeneratedQuery<APITypes.ListAGMProgramVersionQueryVariables, APITypes.ListAGMProgramVersionQuery>;
export const listAGMVersionsAttributeOrder = /* GraphQL */ `query ListAGMVersionsAttributeOrder(
  $input: ListAGMVersionsAttributeOrderInput!
) {
  listAGMVersionsAttributeOrder(input: $input) {
    agm_attributes_order {
      attribute_type
      attribute_type_label
      order
    }
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
  }
}
` as GeneratedQuery<APITypes.ListAGMVersionsAttributeOrderQueryVariables, APITypes.ListAGMVersionsAttributeOrderQuery>;
export const listAllRPNAliasHistory = /* GraphQL */ `query ListAllRPNAliasHistory {
  listAllRPNAliasHistory {
    alias
    is_current
    is_deprecated
    rpn_id
    updated_at
  }
}
` as GeneratedQuery<APITypes.ListAllRPNAliasHistoryQueryVariables, APITypes.ListAllRPNAliasHistoryQuery>;
export const listAnnouncementsDetails = /* GraphQL */ `query ListAnnouncementsDetails {
  listAnnouncementsDetails {
    announcement_date
    announcement_id
    announcement_message
    announcement_title
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
  }
}
` as GeneratedQuery<APITypes.ListAnnouncementsDetailsQueryVariables, APITypes.ListAnnouncementsDetailsQuery>;
export const listAttributeDetails = /* GraphQL */ `query ListAttributeDetails($pagination: PaginationInput) {
  listAttributeDetails(pagination: $pagination) {
    data {
      attribute_level_label
      attribute_type_id
      attribute_type_justification
      attribute_type_label
      attribute_type_status
      attribute_value_details {
        attribute_value_id
        attribute_value_justification
        attribute_value_label
        attribute_value_status
        fpn_count
        item_metadata {
          created_at
          created_by
          is_active
          updated_at
          updated_by
        }
        product_line_count
        rpn_count
      }
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
    }
    pagination {
      current_page
      has_next
      has_previous
      page_size
      total_count
      total_pages
    }
  }
}
` as GeneratedQuery<APITypes.ListAttributeDetailsQueryVariables, APITypes.ListAttributeDetailsQuery>;
export const listAttributeListFPN = /* GraphQL */ `query ListAttributeListFPN($input: FPNIdInput!) {
  listAttributeListFPN(input: $input) {
    asin_count
    attribute_type
    attribute_value
    verity_fpn_id
  }
}
` as GeneratedQuery<APITypes.ListAttributeListFPNQueryVariables, APITypes.ListAttributeListFPNQuery>;
export const listAttributeListRPN = /* GraphQL */ `query ListAttributeListRPN($input: RPNIdInput!) {
  listAttributeListRPN(input: $input) {
    asin_count
    attribute_type
    attribute_value
    rpn
    verity_rpn_id
  }
}
` as GeneratedQuery<APITypes.ListAttributeListRPNQueryVariables, APITypes.ListAttributeListRPNQuery>;
export const listAuditDetails = /* GraphQL */ `query ListAuditDetails {
  listAuditDetails {
    additional_info
    audit_log_id
    created_at
    created_by
    operation_type
    page_name
    record_count
    status
  }
}
` as GeneratedQuery<APITypes.ListAuditDetailsQueryVariables, APITypes.ListAuditDetailsQuery>;
export const listChangeHistory = /* GraphQL */ `query ListChangeHistory($input: ListChangeHistoryInput!) {
  listChangeHistory(input: $input) {
    change_id
    created_at
    created_by
    entity_type
    field_changes
    fpn_id
    operation_type
    product_line_id
    record_count
    rpn_id
    section_name
  }
}
` as GeneratedQuery<APITypes.ListChangeHistoryQueryVariables, APITypes.ListChangeHistoryQuery>;
export const listCostCenter = /* GraphQL */ `query ListCostCenter {
  listCostCenter {
    cost_center_code
    cost_center_name
  }
}
` as GeneratedQuery<APITypes.ListCostCenterQueryVariables, APITypes.ListCostCenterQuery>;
export const listCountries = /* GraphQL */ `query ListCountries {
  listCountries {
    country
    country_code
  }
}
` as GeneratedQuery<APITypes.ListCountriesQueryVariables, APITypes.ListCountriesQuery>;
/**
 * Returns the PRODUCT_TYPE attribute value(s) for every FPN, globally, in a single call.
 * An FPN may have more than one PRODUCT_TYPE row, so callers should treat product_type as a set.
 * Used to classify FPNs (DEVICE / ACCESSORY / N/A) for the Compatible Devices dropdown filter
 * without per-FPN attribute fetches.
 */
export const listFpnProductTypes = /* GraphQL */ `
  query ListFpnProductTypes {
    listFpnProductTypes {
      fpn_id
      product_type
    }
  }
`;
/**
 * Returns the reverse "compatible programs" for a device RPN, derived at read time from the
 * accessory-side (stored) COMPATIBLE PROGRAMS attribute. For the given RPN's device FPNs, it finds
 * every accessory FPN whose COMPATIBLE PROGRAMS value references that device FPN (FPN::<deviceAlias>)
 * or the device's RPN (RPN::<rpnAlias>). One entry per (device FPN, accessory FPN) pair.
 * There is no stored reverse value; this is computed server-side.
 */
export const listCompatibleProgramsReverse = /* GraphQL */ `
  query ListCompatibleProgramsReverse($input: RPNIdInput!) {
    listCompatibleProgramsReverse(input: $input) {
      device_fpn_id
      device_fpn_alias
      accessory_fpn_id
      accessory_fpn_alias
    }
  }
`;
export const listFPNDetails = /* GraphQL */ `query ListFPNDetails($input: ListFPNDetailsInput!) {
  listFPNDetails(input: $input) {
    attributes {
      fpn_distinct_product_line_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      fpn_distinct_program_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      fpn_distinct_standard_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      number_of_asins
      product_line_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      program_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      standard_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
    }
    financial_info {
      didm_refreshed_at
      financial_info_comments
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      remorse_policy
      us_msrp_usd
      warranty_offering
      ww_asp_usd
      ww_msrp_usd
      ww_net_promo_percent
    }
    fpn_alias
    fpn_display_id
    fpn_id
    fpn_ai_description
    fpn_program_overview {
      product_subcategory
      product_tier
      program_complexity
      program_predecessor
    }
    is_confidential
    key_dates {
      didm_refreshed_at
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      other_key_dates {
        end_of_life
        end_of_manufacturing
        end_of_security_upgrades
        end_of_software_support
        last_freshlot_sale_month_qtr
        last_pdp_gate_month
        product_announce_pa_date
      }
      street_dates {
        country_street_dates {
          country
          country_code
          street_date
        }
        first_street_date
        fsd_countries
      }
    }
    manufacturing_info {
      cost_center_code
      hw_program_size
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      manufacturer_company
      manufacturing_engagement
      manufacturing_info_comments
      number_of_manufacturers
      partiness
      product_life_in_months
      project_hw_id
    }
    market_info {
      global_life_volume_est
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      market_info_comments
      primary_or_expansion_launch
      significance_vol_at_resellers
    }
    pl_fpn_rule
    pm_owners
    product_line_id
    rpn_alias
    rpn_display_id
    rpn_fpn_rule
    rpn_id
    specifications {
      alexa_enabled
      camera_enabled
      display_enabled
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      mic_enabled
      mic_field_range
      new_soc
      os
      project_coa
      soc_name
      soc_partiness
      specifications_comments
    }
    updated_at
    updated_by
  }
}
` as GeneratedQuery<APITypes.ListFPNDetailsQueryVariables, APITypes.ListFPNDetailsQuery>;
export const listFPNSkus = /* GraphQL */ `query ListFPNSkus($input: FPNIdInput!) {
  listFPNSkus(input: $input) {
    additional_marketplaces
    asin
    asin_ai_description
    assortment_ids
    blocked_ts
    channel
    country
    fpn
    fpn_display_id
    fpn_id
    is_pn_requested
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    market_place
    notification_status
    part_number
    sku_id
    sku_type
    version_description
    version_id
  }
}
` as GeneratedQuery<APITypes.ListFPNSkusQueryVariables, APITypes.ListFPNSkusQuery>;
export const listFormFieldMetadata = /* GraphQL */ `query ListFormFieldMetadata {
  listFormFieldMetadata {
    fields {
      fieldName
      label
      options {
        id
        value
      }
    }
  }
}
` as GeneratedQuery<APITypes.ListFormFieldMetadataQueryVariables, APITypes.ListFormFieldMetadataQuery>;
export const listGanttChartDetails =
  /* GraphQL */ `query ListGanttChartDetails($chart_filters: GanttChartFiltersInput) {
  listGanttChartDetails(chart_filters: $chart_filters) {
    body {
      product_code
      product_line_alias
      product_line_id
      rpns {
        country_street_dates {
          country
          date
        }
        first_street_date
        fpns {
          fpn_alias
          fpn_display_id
          fpn_id
          msrp
        }
        hw_development_status
        is_brd_approved
        is_confidential
        is_name_approved
        is_on_roadmap
        prfaq_approval_status
        product_life_months
        product_line_metadata {
          product_subcategory
          product_tier
          program_complexity
          program_predecessor
        }
        program_rpn_alias
        program_status
        rpn_display_id
        rpn_id
        selected_msrp_fpn_id
      }
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.ListGanttChartDetailsQueryVariables, APITypes.ListGanttChartDetailsQuery>;
export const listMandatoryAttributes = /* GraphQL */ `query ListMandatoryAttributes {
  listMandatoryAttributes {
    attribute_type_label
    product_code
    product_line
    product_line_id
  }
}
` as GeneratedQuery<APITypes.ListMandatoryAttributesQueryVariables, APITypes.ListMandatoryAttributesQuery>;
export const listMarketplaces = /* GraphQL */ `query ListMarketplaces {
  listMarketplaces {
    country
    marketplace
    obfuscated_marketplace_id
  }
}
` as GeneratedQuery<APITypes.ListMarketplacesQueryVariables, APITypes.ListMarketplacesQuery>;
export const listProductHierarchy = /* GraphQL */ `query ListProductHierarchy($pagination: PaginationInput) {
  listProductHierarchy(pagination: $pagination) {
    data {
      asin_count
      children {
        alexa_enabled
        asin_count
        camera_enabled
        children {
          alexa_enabled
          asin_count
          camera_enabled
          first_street_date
          fpn_alias
          fpn_display_id
          fpn_id
          fsd_countries
          is_active
          mic_enabled
          os
          project_coa
          updated_at
          updated_by
          us_msrp_usd
          ww_msrp_usd
        }
        global_life_volume_est
        is_active
        is_brd_approved
        is_confidential
        is_name_approved
        is_on_roadmap
        mic_enabled
        os
        partiness
        prfaq_approval_status
        prfaq_link
        primary_or_expansion_launch
        product_life_in_months
        product_sub_category
        product_tier
        program_complexity
        program_predecessor
        program_status
        project_coa
        rpn_alias
        rpn_display_id
        rpn_id
        rpn_old_aliases
        significance_vol_at_resellers
        updated_at
        updated_by
      }
      is_active
      is_visible
      product_code
      product_line
      product_line_id
      updated_at
      updated_by
    }
    pagination {
      current_page
      has_next
      has_previous
      page_size
      total_count
      total_pages
    }
  }
}
` as GeneratedQuery<APITypes.ListProductHierarchyQueryVariables, APITypes.ListProductHierarchyQuery>;
export const listProductHierarchyMinimal =
  /* GraphQL */ `query ListProductHierarchyMinimal($pagination: PaginationInput) {
  listProductHierarchyMinimal(pagination: $pagination) {
    data {
      asin_count
      children {
        asin_count
        children {
          asin_count
          fpn_alias
          fpn_display_id
          fpn_id
          is_active
          updated_at
          updated_by
        }
        is_active
        is_confidential
        ppls_id
        program_status
        rpn_alias
        rpn_display_id
        rpn_id
        updated_at
        updated_by
      }
      is_active
      is_visible
      product_code
      product_line
      product_line_group
      product_line_id
      updated_at
      updated_by
    }
    pagination {
      current_page
      has_next
      has_previous
      page_size
      total_count
      total_pages
    }
  }
}
` as GeneratedQuery<APITypes.ListProductHierarchyMinimalQueryVariables, APITypes.ListProductHierarchyMinimalQuery>;
export const listProductLineContacts = /* GraphQL */ `query ListProductLineContacts {
  listProductLineContacts {
    asin_owners {
      badge_color
      business_title
      cost_center_name
      employee_status
      first_name
      job_status
      last_name
      legacy_employee_id
      login
      person_id
    }
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    pl_admins {
      badge_color
      business_title
      cost_center_name
      employee_status
      first_name
      job_status
      last_name
      legacy_employee_id
      login
      person_id
    }
    pl_escalation_managers {
      badge_color
      business_title
      cost_center_name
      employee_status
      first_name
      job_status
      last_name
      legacy_employee_id
      login
      person_id
    }
    product_line_id
    product_line_name
  }
}
` as GeneratedQuery<APITypes.ListProductLineContactsQueryVariables, APITypes.ListProductLineContactsQuery>;
export const listProductLineDetails = /* GraphQL */ `query ListProductLineDetails {
  listProductLineDetails {
    is_active
    is_visible
    product_code
    product_line
    product_line_group
    product_line_id
    rpn_count
    updated_at
    updated_by
  }
}
` as GeneratedQuery<APITypes.ListProductLineDetailsQueryVariables, APITypes.ListProductLineDetailsQuery>;
export const listProductLineGroup = /* GraphQL */ `query ListProductLineGroup {
  listProductLineGroup {
    description
    id
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    product_line_group
  }
}
` as GeneratedQuery<APITypes.ListProductLineGroupQueryVariables, APITypes.ListProductLineGroupQuery>;
export const listProductLines = /* GraphQL */ `query ListProductLines {
  listProductLines {
    is_active
    product_code
    product_line
    verity_product_line_id
  }
}
` as GeneratedQuery<APITypes.ListProductLinesQueryVariables, APITypes.ListProductLinesQuery>;
export const listRPNAssortments = /* GraphQL */ `query ListRPNAssortments($input: RPNIdInput!) {
  listRPNAssortments(input: $input) {
    assortment_channel
    assortment_country
    assortment_id
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    marketplace
    obfuscated_marketplace_id
    sku_type
    status
    version_description
    version_id
  }
}
` as GeneratedQuery<APITypes.ListRPNAssortmentsQueryVariables, APITypes.ListRPNAssortmentsQuery>;
export const listRPNDetails = /* GraphQL */ `query ListRPNDetails($input: ListRPNDetailsInput) {
  listRPNDetails(input: $input) {
    attributes {
      fpn_distinct_product_line_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      fpn_distinct_program_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      fpn_distinct_standard_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      number_of_asins
      product_line_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      program_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
      standard_attributes {
        attribute_type_id
        attribute_type_label
        in_fpn
        order
        selected_values
      }
    }
    key_dates {
      didm_refreshed_at
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      other_key_dates {
        end_of_life
        end_of_manufacturing
        end_of_security_upgrades
        end_of_software_support
        last_freshlot_sale_month_qtr
        last_pdp_gate_month
        product_announce_pa_date
      }
      street_dates {
        country_street_dates {
          country
          country_code
          street_date
        }
        first_street_date
        fsd_countries
      }
    }
    manufacturing_info {
      cost_center_code
      hw_program_size
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      manufacturer_company
      manufacturing_engagement
      manufacturing_info_comments
      number_of_manufacturers
      partiness
      product_life_in_months
      project_hw_id
    }
    market_info {
      global_life_volume_est
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      market_info_comments
      primary_or_expansion_launch
      significance_vol_at_resellers
    }
    pl_fpn_rule
    ppls_id
    product_code
    product_line
    product_line_id
    rpn_alias
    rpn_display_id
    rpn_fpn_rule
    rpn_id
    rpn_old_aliases
    rpn_overview {
      documents_links {
        url_links {
          link_description
          url
        }
      }
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      pm_owners
      rpn_program_overview {
        compatible_devices
        major_call_outs
        product_sub_category
        product_tier
        program_comments
        program_complexity
        program_description
        program_name
        program_predecessor
      }
      rpn_status {
        is_brd_approved
        is_confidential
        is_name_approved
        is_on_roadmap
        prfaq_approval_status
        prfaq_link
        program_creation_date
        program_status
      }
    }
    specifications {
      alexa_enabled
      camera_enabled
      display_enabled
      item_metadata {
        created_at
        created_by
        is_active
        updated_at
        updated_by
      }
      mic_enabled
      mic_field_range
      new_soc
      os
      project_coa
      soc_name
      soc_partiness
      specifications_comments
    }
    rpn_ai_description
    updated_at
    updated_by
  }
}
` as GeneratedQuery<APITypes.ListRPNDetailsQueryVariables, APITypes.ListRPNDetailsQuery>;
export const listRPNFPNRule = /* GraphQL */ `query ListRPNFPNRule($input: RPNIdInput!) {
  listRPNFPNRule(input: $input) {
    attribute_type
    comments
    concat_order
    is_deprecated
    ppls_id
    product_line
    rpn
    verity_product_line_id
    verity_rpn_id
  }
}
` as GeneratedQuery<APITypes.ListRPNFPNRuleQueryVariables, APITypes.ListRPNFPNRuleQuery>;
export const listRPNSkus = /* GraphQL */ `query ListRPNSkus($input: RPNIdInput!) {
  listRPNSkus(input: $input) {
    additional_marketplaces
    asin
    asin_ai_description
    assortment_ids
    blocked_ts
    channel
    country
    fpn
    fpn_display_id
    fpn_id
    is_pn_requested
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    market_place
    notification_status
    part_number
    sku_id
    sku_type
    version_description
    version_id
  }
}
` as GeneratedQuery<APITypes.ListRPNSkusQueryVariables, APITypes.ListRPNSkusQuery>;
export const listRPNVersions = /* GraphQL */ `query ListRPNVersions($input: RPNIdInput!) {
  listRPNVersions(input: $input) {
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    version_config
    version_description
    version_id
  }
}
` as GeneratedQuery<APITypes.ListRPNVersionsQueryVariables, APITypes.ListRPNVersionsQuery>;
export const listReportConfig = /* GraphQL */ `query ListReportConfig {
  listReportConfig {
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    report_col_definition
    report_description
    report_group_name
    report_id
    report_location_details
    report_location_type
    report_name
    report_unique_code
    report_visibility_level
  }
}
` as GeneratedQuery<APITypes.ListReportConfigQueryVariables, APITypes.ListReportConfigQuery>;
export const listResourcesDetails = /* GraphQL */ `query ListResourcesDetails {
  listResourcesDetails {
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    resource_id
    resource_link
    resource_name
    resource_order_number
  }
}
` as GeneratedQuery<APITypes.ListResourcesDetailsQueryVariables, APITypes.ListResourcesDetailsQuery>;
export const listSkuSearch = /* GraphQL */ `query ListSkuSearch($searchTerm: String!) {
  listSkuSearch(searchTerm: $searchTerm) {
    data {
      asin
      fpn_alias
      fpn_display_id
      fpn_id
      is_confidential
      part_number
      product_code
      product_line_id
      product_line_name
      rpn_alias
      rpn_display_id
      rpn_id
    }
  }
}
` as GeneratedQuery<APITypes.ListSkuSearchQueryVariables, APITypes.ListSkuSearchQuery>;
export const listSnapshotScenarios =
  /* GraphQL */ `query ListSnapshotScenarios($is_automatic: Boolean, $scenario_id: Int) {
  listSnapshotScenarios(
    is_automatic: $is_automatic
    scenario_id: $scenario_id
  ) {
    is_automatic
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    scenario_snapshot_id
    scenario_snapshot_name
    scenario_snapshot_note
  }
}
` as GeneratedQuery<APITypes.ListSnapshotScenariosQueryVariables, APITypes.ListSnapshotScenariosQuery>;
export const listUserAccess = /* GraphQL */ `query ListUserAccess($user_alias: String) {
  listUserAccess(user_alias: $user_alias) {
    is_dev
    is_read_only
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    papi_info {
      badge_color
      business_title
      cost_center_name
      employee_status
      first_name
      job_status
      last_name
      legacy_employee_id
      login
      person_id
    }
    product_lines_access {
      has_confidential_access
      is_pl_admin
      product_line_id
    }
    user_access_id
    user_alias
    user_type
  }
}
` as GeneratedQuery<APITypes.ListUserAccessQueryVariables, APITypes.ListUserAccessQuery>;
export const listUserFavorites = /* GraphQL */ `query ListUserFavorites {
  listUserFavorites {
    fpn_ids
    product_line_ids
    rpn_ids
  }
}
` as GeneratedQuery<APITypes.ListUserFavoritesQueryVariables, APITypes.ListUserFavoritesQuery>;
export const listUserMetrics = /* GraphQL */ `query ListUserMetrics {
  listUserMetrics {
    distinct_users
    formatted_log_month
    log_month
  }
}
` as GeneratedQuery<APITypes.ListUserMetricsQueryVariables, APITypes.ListUserMetricsQuery>;
export const listUserPreferencesDetails = /* GraphQL */ `query ListUserPreferencesDetails($user_alias: String!) {
  listUserPreferencesDetails(user_alias: $user_alias) {
    item_metadata {
      created_at
      created_by
      is_active
      updated_at
      updated_by
    }
    preferences
    user_alias
  }
}
` as GeneratedQuery<APITypes.ListUserPreferencesDetailsQueryVariables, APITypes.ListUserPreferencesDetailsQuery>;
export const ppls_get_program =
  /* GraphQL */ `query Ppls_get_program($id: String, $name: String, $requested_by: String) {
  ppls_get_program(id: $id, name: $name, requested_by: $requested_by) {
    body {
      actorType
      conceptId
      confidential
      createdAt
      createdBy
      description
      id
      internalId
      name
      productLineIds
      resourceName
      sourceId
      status
      team {
        actorId
        actorType
        alias
      }
    }
    error
    statusCode
  }
}
` as GeneratedQuery<APITypes.Ppls_get_programQueryVariables, APITypes.Ppls_get_programQuery>;
